import { getCountry } from '@insio/countries';
import { CurrencyCode, getCurrency } from './currencies';

/** Accounting currency of an organization whose country gives no known currency. */
export const DEFAULT_ACCOUNTING_CURRENCY: CurrencyCode = CurrencyCode.CZK;

/** The supported currency of a country, or undefined when it has none or is unknown. */
export function currencyOfCountry(
  countryCode: string | null | undefined
): CurrencyCode | undefined {
  return getCurrency(getCountry(countryCode)?.currencyCode)?.code;
}

/** Accounting currency for an organization in the given country (any casing), else CZK. */
export function accountingCurrencyForCountry(countryCode: string | null | undefined): CurrencyCode {
  return currencyOfCountry(countryCode) ?? DEFAULT_ACCOUNTING_CURRENCY;
}
